import React from "react";
import { observer } from "mobx-react";

import { CustomSnackbar } from "./styles";

export type SnackbarProps = {
  message: string;
  type: string;
  onClose: () => void;
};

export const SNACKBAR_TYPES = {
  ERROR: "Error",
  INFO: "Info",
  SUCCESS: "Success",
};

@observer
class Snackbar extends React.Component<SnackbarProps> {
  render() {
    const { message, type, onClose } = this.props;

    return (
      <CustomSnackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        autoHideDuration={5000}
        open={!!message}
        message={message}
        onClose={onClose}
        type={type}
        transitionDuration={0}
      />
    );
  }
}

export default Snackbar;
